
import axios from 'axios';

export const transactions = params => {
  axios.post('/v1/providerapp/logging/transactions', params)
  .then(response => {return response})
  .catch(error => error);
}

export default transactions;
